module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_5.4d55b57d.png";